import cn from "classnames";
import { AddressPicker, CONSIGNEE_MESSAGES } from "components/bid/form/partials/pointElem";
import PlanLeaveDate from "components/bid/form/partials/pointElem/planLeaveDate";
import SimpleDatetime from "components/shared/datetime";
import { Field, Flags, Select } from "components/shared/form";
import { counterpartyInsolvency } from "helpers/bid";
import { formatDateTimezone } from "helpers/bidpoint";
import {
    bidPointOptionFlags,
    bidPointOptionFlagsEnum,
    bidPointTypes,
    bidPointTypesEnum,
    featureModuleTypesEnum,
} from "helpers/enums";
import { enumLabel, pointLetter } from "helpers/system";
import { phoneNumber as phoneValidator, requiredField } from "helpers/validators";
import React, { Component } from "react";
import { getBidContact } from "sources/books/bids";
import { list as customPointTypesReq } from "sources/books/customPointTypes";
import { list as scenariosList } from "sources/books/scenarios";

export default class Point extends Component {
    state = {
        isLoading: false,
        currentMessage: "",
    };

    constructor(props) {
        super(props);

        this.isCustomPoint = bidPointTypesEnum.CustomPoint === props.item.type;
    }

    setValue = ({ name, value, option }) => {
        const { onChange, i } = this.props;
        onChange({ name, value }, i);
        if (name === "counterpartyId") {
            this.props.updateCounterpartiesData(value, option);
        }
    };

    toggleSecondaryPlanEnterDate = () => {
        const value = this.props.item.secondaryPlanEnterDate ? null : this.props.item.planEnterDate;
        this.setValue({ name: "secondaryPlanEnterDate", value });
    };

    renderOrderTopArrow = () => {
        const { i, reorder, availableFeatureModules } = this.props;
        if (
            this.isCustomPoint &&
            i === 1 &&
            !availableFeatureModules.includes(featureModuleTypesEnum.PlanEmptyMileageBid)
        ) {
            return null;
        }
        const cname = "book-form__section-arrow book-form__section-arrow--top";
        const action = () => reorder(i, i - 1);
        return i !== 0 && <span className={cname} onClick={action} title="Вверх в очереди" />;
    };

    renderOrderBottomArrow = () => {
        const { i, items, reorder } = this.props;
        if (this.isCustomPoint && i === items.length - 2) {
            return null;
        }
        const cname = "book-form__section-arrow book-form__section-arrow--bottom";
        const action = () => reorder(i, i + 1);
        return 1 + i < items.length && <span className={cname} onClick={action} title="Вниз в очереди" />;
    };

    setConsigneeValue = ({ name, value }) => {
        if (name === "phoneNumber") {
            if (!phoneValidator(value)) {
                this.setState({ currentMessage: CONSIGNEE_MESSAGES.load, isLoading: true });
                getBidContact({ phoneNumber: value }).then((res) => {
                    if (res && res.name) {
                        this.setState({ currentMessage: CONSIGNEE_MESSAGES.success, isLoading: false });
                        this.setConsigneeValue({ name: "name", value: res.name });
                    } else {
                        this.setState({ currentMessage: CONSIGNEE_MESSAGES.error, isLoading: false });
                    }
                });
            } else {
                this.setState({ currentMessage: "", isLoading: true });
            }
        }
        this.setValue({ name: "contactPerson", value: { ...this.props.item.contactPerson, [name]: value } });
    };

    currentMessage = () => {
        if (this.state.currentMessage.length) {
            return (
                <small className="text-info offset-sm-4 offset-md-3 col-sm-8 col-md-5">
                    {this.state.currentMessage}
                </small>
            );
        }
    };

    render() {
        const {
            config,
            item,
            switchMap,
            i,
            remove,
            counterpartiesData,
            bidCounterpartyId,
            items,
            availableFeatureModules,
            modal,
            organization,
            profile,
            roles,
        } = this.props;
        const {
            geozone,
            planEnterDate,
            type,
            secondaryPlanEnterDate,
            loadOptions,
            client,
            comment,
            contactPerson,
            intOptions,
            planLeaveDate,
            counterpartyId,
            scenarioId,
            externalCity,
        } = item;
        const isBidPoint = type !== bidPointTypesEnum.ServicePoint;
        const removePoint = () => {
            return modal({
                name: "confirm",
                title: "Удаление точки",
                text: "Вы уверены, что хотите удалить точку маршрута?",
                action: () => {
                    remove(i);
                    setTimeout(this.props.onPointRemoved, 100);
                },
            });
        };
        const utcTimezone = !!item.id && formatDateTimezone(item);
        const unresolvedAddressWarning =
            this.props.showUnresolvedAddressWarning && !geozone?.address && externalCity ? (
                <div className="alert alert-danger mt-2 mb-0 py-2 small" role="alert">
                    <div>Не удалось автоматически определить точный адрес по данным ЭЗЗ:</div>
                    <i className="d-block">&quot;{externalCity}&quot;.</i>
                    <div>Нажмите на поле &quot;Адрес&quot; и выберите подходящую точку на карте вручную.</div>
                </div>
            ) : null;
        return (
            <div>
                <div className="book-form__section-head book-form__section-head--closable">
                    <div
                        className="book-form__section-close close book-form__section-close--point"
                        onClick={removePoint}
                        title="Удалить точку"
                    />
                    <div className="form-group">
                        <div className="book-form__section-head--point-icon">{pointLetter(i)}</div>
                        <strong>{enumLabel(bidPointTypes, type)}</strong>
                    </div>
                    <div className="book-form__section-arrows">
                        {this.renderOrderTopArrow()}
                        {this.renderOrderBottomArrow()}
                    </div>
                </div>
                <div>
                    {!client && !this.isCustomPoint && this.props.config.counterpartyId && (
                        <Select
                            {...this.props.config.counterpartyId}
                            wrapper="book-field"
                            fieldWrapper="col-sm-8 col-md-5"
                            onChange={this.setValue}
                            value={counterpartyId}
                            index={i}
                            modal={modal}
                            organization={organization}
                            profile={profile}
                            roles={roles}
                            label={type === bidPointTypesEnum.LoadPoint ? "Грузоотправитель" : "Грузополучатель"}
                            inputBottomText={
                                <>
                                    <div>
                                        {counterpartyInsolvency(
                                            counterpartiesData[counterpartyId]?.insolvencyRegistryEntry,
                                        )}
                                    </div>
                                    <small>
                                        <i className="text-muted">{counterpartiesData[counterpartyId]?.comment}</i>
                                    </small>
                                </>
                            }
                        />
                    )}
                    {this.isCustomPoint && (
                        <Select
                            wrapper="book-field"
                            fieldWrapper="col-sm-8 col-md-5"
                            inputProps={{
                                name: "customPointTypeId",
                            }}
                            propName="name"
                            url={customPointTypesReq}
                            onChange={this.setValue}
                            value={item.customPointTypeId}
                            index={i}
                            required
                            unClearable
                            validators={[requiredField]}
                            label="Тип точки"
                        />
                    )}
                    <AddressPicker
                        {...{
                            i,
                            withoutPostamat: true,
                            counterpartiesData,
                            bidPointType: type,
                            geozone,
                            switchMap,
                            bidCounterpartyId,
                            cargoOwnerDictionaryItemId: counterpartyId,
                            onChange: this.setValue,
                            modal: this.props.modal,
                            availableFeatureModules,
                            additionalInputBottomText: unresolvedAddressWarning,
                        }}
                    />
                    <div className="row form-group">
                        <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left field-wrap__label--required">
                            Дата прибытия
                        </label>
                        <div className="col-sm-8 col-md-9">
                            <div className="row">
                                <div className="col-auto">
                                    <SimpleDatetime
                                        inPortal
                                        wrapper="date-filter"
                                        inputProps={{
                                            name: "planEnterDate",
                                            type: "datetime",
                                        }}
                                        index={i}
                                        onChange={this.setValue}
                                        value={planEnterDate}
                                        validators={[requiredField]}
                                    />
                                </div>
                                {config.secondaryPlanEnterDate &&
                                    !config.secondaryPlanEnterDate.isHidden &&
                                    secondaryPlanEnterDate && (
                                        <>
                                            <div className="col-auto col-form-label col-form-label-sm text-center px-0">
                                                &mdash;
                                            </div>
                                            <div className="col-auto">
                                                <SimpleDatetime
                                                    inPortal
                                                    wrapper="date-filter"
                                                    inputProps={{
                                                        name: "secondaryPlanEnterDate",
                                                        type: "datetime",
                                                    }}
                                                    index={i}
                                                    onChange={this.setValue}
                                                    value={secondaryPlanEnterDate}
                                                />
                                            </div>
                                        </>
                                    )}
                                {utcTimezone && (
                                    <span className="col-auto col-form-label col-form-label-sm pl-0">
                                        {utcTimezone}
                                    </span>
                                )}
                            </div>
                            {config.secondaryPlanEnterDate && !config.secondaryPlanEnterDate.isHidden && (
                                <div
                                    className="col-form-label-sm d-inline-block"
                                    onClick={this.toggleSecondaryPlanEnterDate}
                                >
                                    <div
                                        className={cn("checkbox d-inline-block", {
                                            "checkbox--checked": secondaryPlanEnterDate,
                                        })}
                                    />
                                    &nbsp;
                                    <div className="d-inline-block checkbox__text">Диапазон дат</div>
                                </div>
                            )}
                        </div>
                    </div>
                    <PlanLeaveDate
                        {...{
                            availableFeatureModules,
                            utcTimezone,
                            type,
                            i,
                            value: planLeaveDate,
                            onChange: this.setValue,
                        }}
                    />
                    {!this.isCustomPoint && (
                        <Select
                            isMulti
                            wrapper="book-field"
                            fieldWrapper="col-sm-8 col-md-5"
                            inputProps={{
                                name: "loadOptions",
                            }}
                            options={this.props.enums.loadUnloadType}
                            onChange={({ name, value }) => this.setValue({ name, value: value.map((id) => ({ id })) })}
                            value={(loadOptions || []).map((option) => option.id)}
                            index={i}
                            label={type === bidPointTypesEnum.LoadPoint ? "Типы погрузки" : "Типы выгрузки"}
                        />
                    )}
                    {this.props.config.comment && (
                        <Field
                            textarea
                            {...this.props.config.comment}
                            fieldWrapper="col-sm-8 col-md-5"
                            label="Комментарий"
                            inputProps={{
                                name: "comment",
                            }}
                            onChange={this.setValue}
                            value={comment}
                            index={i}
                        />
                    )}
                    {client && !this.isCustomPoint && (
                        <Field
                            fieldWrapper="col-sm-8 col-md-5"
                            label="Клиент"
                            inputProps={{
                                name: "client",
                            }}
                            onChange={this.setValue}
                            value={client}
                            index={i}
                        />
                    )}
                    {this.props.config.contactPerson && (
                        <>
                            <div className="form-group">
                                <Field
                                    {...this.props.config.contactPerson}
                                    label="Мобильный телефон"
                                    fieldWrapper="col-sm-8 col-md-5"
                                    bWrapper="row"
                                    inputProps={{
                                        name: "phoneNumber",
                                    }}
                                    onChange={this.setConsigneeValue}
                                    value={contactPerson ? contactPerson.phoneNumber : ""}
                                    index={i}
                                />
                                {this.currentMessage()}
                            </div>
                            <Field
                                {...this.props.config.contactPerson}
                                label="Контактное лицо"
                                inputProps={{
                                    name: "name",
                                }}
                                fieldWrapper="col-sm-8 col-md-5"
                                onChange={this.setConsigneeValue}
                                value={contactPerson ? contactPerson.name : ""}
                                index={i}
                            />
                        </>
                    )}
                    <Field
                        fieldWrapper="col-sm-8 col-md-5"
                        {...this.props.config.externalCity}
                        onChange={this.setValue}
                        value={externalCity}
                        index={i}
                    />
                    {items.length === i + 1 && (
                        <Flags
                            label="Опции точки маршрута"
                            onChange={this.setValue}
                            flags={bidPointOptionFlags.filter(
                                (item) =>
                                    ![
                                        bidPointOptionFlagsEnum.EmptyMileagePoint,
                                        bidPointOptionFlagsEnum.EstimatedDateAsPlanned,
                                    ].includes(item.value),
                            )}
                            inputProps={{ name: "intOptions" }}
                            value={intOptions || 0}
                            index={i}
                            fieldWrapper="col-sm-8 col-md-5"
                            tooltip='Установка флага означает, что выгрузка не начнется раньше времени, указанном в поле "Выгрузка начнется в" независимо от времени приезда машины на выгрузку'
                        />
                    )}
                    {!this.isCustomPoint && availableFeatureModules.includes(featureModuleTypesEnum.Scenarios) && (
                        <Select
                            wrapper="book-field"
                            fieldWrapper="col-sm-8 col-md-5"
                            inputProps={{
                                name: "scenarioId",
                            }}
                            propName="name"
                            menuPortalTarget={document.body}
                            url={scenariosList}
                            onChange={this.setValue}
                            value={scenarioId}
                            index={i}
                            disabled={!isBidPoint}
                            label="Сценарий"
                        />
                    )}
                </div>
            </div>
        );
    }
}
